const adaptProfesional = (profesional) => {
  const { idProfesional, nombre, apellido, idCalificacion, idClaseMonitoreo } = profesional;

  return {
    id: idProfesional,
    displayName: `${apellido} ${nombre}`,
    idCalificacion: idCalificacion,
    idClaseMonitoreo: idClaseMonitoreo
  };
};

export const adaptProfesionales = (data) => {
  const adaptedData = data?.profesionalesAsistencial?.map((profesional) =>
    adaptProfesional(profesional)
  );

  return adaptedData;
};
